import { useQuery, UseQueryResult } from 'react-query';
import { AppointmentAthleteRetrieve } from 'types';
import { client } from 'utils/api-client';

// Keyed under ['appointments', id] so the booking mutations' invalidations still reach it.
function useAppointmentAthleteRetrieve(
  appointmentId: string | undefined,
): UseQueryResult<{ data: AppointmentAthleteRetrieve }> {
  return useQuery(
    ['appointments', appointmentId, 'athlete-retrieve'],
    () => client.get(`appointments/${appointmentId}/athlete-retrieve/`),
    { enabled: !!appointmentId },
  );
}

export default useAppointmentAthleteRetrieve;
